import { useEffect, useState } from 'react';
import { addMonthsToDate, isSameMonth, subtractMonthsFromDate } from '../../utils/dateFormat';
import usePrevious from '../../hooks/usePrevious';
import { CalendarEvent } from '../../api/types/event';

const useCalendar = ({
  refreshEvents,
  initialDate,
}: {
  refreshEvents: (date: string) => Promise<void>;
  initialDate: Date;
}) => {
  const [selectedDate, setSelectedDate] = useState<Date>(initialDate || new Date());
  const previousSelectedDate = usePrevious<Date>(selectedDate);
  const [eventsData, setEventsData] = useState<CalendarEvent[]>([]);

  const updateEvents = (events: CalendarEvent[]) => {
    setEventsData(events);
  };

  useEffect(() => {
    if (!isSameMonth(selectedDate, previousSelectedDate)) {
      refreshEvents(selectedDate.toISOString()).then();
    }
  }, [selectedDate]);

  const onTodayPress = () => {
    setSelectedDate(new Date());
  };
  const onNextPress = () => {
    setSelectedDate(addMonthsToDate(selectedDate, 1));
  };
  const onPreviousPress = () => {
    setSelectedDate(subtractMonthsFromDate(selectedDate, 1));
  };
  const onSelectDateFromCalendar = (value: Date | null) => {
    if (value !== null) {
      setSelectedDate(new Date(value));
    }
  };

  return {
    selectedDate,
    eventsData,
    updateEvents,
    onTodayPress,
    onNextPress,
    onPreviousPress,
    onSelectDateFromCalendar,
  };
};

export default useCalendar;
